import './style.scss';
import { FC } from 'react';
import { RestaurantCardProps } from '../restaurantCard.types';

import { newCopiaStore } from '../../../../modules/copia/newCopia.store';

const RestaurantCardView: FC<RestaurantCardProps> = ({ room, index }) => {
  const { setCurrentMenu } = newCopiaStore;

  return (
    <div className="restaurantCardContent">
      <div>
        <h2 className="restaurantCardTitle">{room.name}</h2>
        <p className="restaurantCardDesc">
          {room?.restaurantCuisines?.map((cuisine) => cuisine.name).join(', ')}{' '}
          cuisines
        </p>
      </div>
      <div className="restaurantCardFooter">
        <div className="restaurantCardFooterCell">
          <p className="restaurantCardAmount">$ - $$$</p>
          <span
            className="restaurantCardMenu"
            onClick={(e) => {
              e.stopPropagation();
              setCurrentMenu(index);
            }}
          >
            Menu
          </span>
        </div>
        <div className="restaurantCardFooterCell">
          <p className="restaurantRating">
            <i className="icon-star" />
            4.92 (34)
          </p>
        </div>
      </div>
    </div>
  );
};

export default RestaurantCardView;
